/**
 * @classdesc Ukrainian Language Pack
 * @desc This class will used to translate tokens into the Ukrainian language.
 * @namespace Languages.Ukrainian
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Ukrainian
 */
export const dictionary = {
    'years'   : 'роки',
    'months'  : 'місяці',
    'days'    : 'дні',
    'hours'   : 'години',
    'minutes' : 'хвилини',
    'seconds' : 'секунди'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Ukrainian
 */
export const aliases = ['ua', 'ua-ua', 'ukraine'];
